import { PinLevelPermissionBadge } from "./PinLevelPermissionBadge";

export default PinLevelPermissionBadge;
